import { render } from "./DemandList.component.vue?vue&type=template&id=21d9a5ef&scoped=true"
import script from "./DemandList.component.vue?vue&type=script&lang=js"
export * from "./DemandList.component.vue?vue&type=script&lang=js"

import "./DemandList.component.vue?vue&type=style&index=0&id=21d9a5ef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9a5ef"]])

export default __exports__